export const GET_VEHICLES_SUCCESS = "GET_VEHICLES_SUCCESS";
export const GET_VEHICLES_FAILURE = "GET_VEHICLES_FAILURE";
export const SET_VEHICLES_LOADING = "SET_VEHICLES_LOADING";

export const GET_VEHICLES_BY_VIN = "GET_VEHICLES_BY_VIN";
export const GET_VEHICLES_BY_VIN_SUCCESS = "GET_VEHICLES_BY_VIN_SUCCESS";
export const GET_VEHICLES_BY_VIN_FAILURE = "GET_VEHICLES_BY_VIN_FAILURE";

export const GET_FEETYPES = "GET_FEETYPES";
export const GET_FEETYPES_SUCCESS = "GET_FEETYPES_SUCCESS";
export const GET_FEETYPES_FAILURE = "GET_FEETYPES_FAILURE";

export const GET_POPULAR_CARS = "GET_POPULAR_CARS";
export const GET_POPULAR_CARS_SUCCESS = "GET_POPULAR_CARS_SUCCESS";
export const GET_POPULAR_CARS_FAILURE = "GET_POPULAR_CARS_FAILURE";

export const GET_TOP_DEAL_CARS = "GET_TOP_DEAL_CARS";
export const GET_TOP_DEAL_CARS_SUCCESS = "GET_TOP_DEAL_CARS_SUCCESS";
export const GET_TOP_DEAL_CARS_FAILURE = "GET_TOP_DEAL_CARS_FAILURE";

export interface CarState {
  feeTypes: any;
  cars: any;
  carDetail: any;
  popularCars: any;
  loading: boolean;
  error: string | null;
  totalPages: number | null;
  currentPage: number | null;
  totalVehicles: number | null;
  perPage: number | null;
  topDealCars: any;
}

interface GetVehiclesSuccessAction {
  type: typeof GET_VEHICLES_SUCCESS;
  payload: any;
}

interface GetVehiclesFailureAction {
  type: typeof GET_VEHICLES_FAILURE;
  payload: string;
}

interface SetVehiclesLoadingAction {
  type: typeof SET_VEHICLES_LOADING;
}

interface GetVehiclesByVinAction {
  type: typeof GET_VEHICLES_BY_VIN;
  payload: any;
}

interface GetVehiclesByVinSuccess {
  type: typeof GET_VEHICLES_BY_VIN_SUCCESS;
  payload: any;
}

interface GetVehiclesByVinFailure {
  type: typeof GET_VEHICLES_BY_VIN_FAILURE;
  payload: any;
}

interface GetFeeTypes {
  type: typeof GET_FEETYPES;
  payload: any;
}

interface GetFeeTypesSuccess {
  type: typeof GET_FEETYPES_SUCCESS;
  payload: any;
}

interface GetFeeTypesFailure {
  type: typeof GET_FEETYPES_FAILURE;
  payload: any;
}

interface GetPopularCars {
  type: typeof GET_POPULAR_CARS;
  payload: any;
}

interface GetPopularCarsSuccess {
  type: typeof GET_POPULAR_CARS_SUCCESS;
  payload: any;
}

interface GetPopularCarsFailure {
  type: typeof GET_POPULAR_CARS_FAILURE;
  payload: any;
}

interface GetTopDealCars {
  type: typeof GET_TOP_DEAL_CARS;
  payload: any;
}

interface GetTopDealCarsSuccess {
  type: typeof GET_TOP_DEAL_CARS_SUCCESS;
  payload: any;
}

interface GetTopDealCarsFailure {
  type: typeof GET_TOP_DEAL_CARS_FAILURE;
  payload: any;
}

export type VehicleActionTypes =
  | GetVehiclesSuccessAction
  | GetVehiclesFailureAction
  | SetVehiclesLoadingAction
  | GetVehiclesByVinAction
  | GetVehiclesByVinAction
  | GetVehiclesByVinSuccess
  | GetVehiclesByVinFailure
  | GetFeeTypes
  | GetFeeTypesSuccess
  | GetFeeTypesFailure
  | GetPopularCars
  | GetPopularCarsSuccess
  | GetPopularCarsFailure
  | GetTopDealCars
  | GetTopDealCarsSuccess
  | GetTopDealCarsFailure;
